import { FldrObjectWrapper } from '../../shared/wrappers/fldrobject.wrapper';
import { ObjectWrapper } from '../../shared/wrappers/object.wrapper';
import { FldrObject } from '../../shared/models/fldrobject';
import { ListFactory } from '../../shared/caches/list.factory';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ServiceManager } from '../../shared/services/service.manager';
import { Util } from '../../shared/utils/util';
import { CommonEnums } from '../../shared/common.enums';
import { Fldr } from '../../shared/models/datapoint/fldr';
import { SessionFactory } from '../../shared/caches/session.factory';
import { Repository } from './repository';
import { DIMsgObj } from '../../shared/models/dimsgobj';
import { Design } from '../../shared/models/domain/design';
import { DesignWrapper } from 'src/app/modules/design/design.wrapper';
import { RecentObjectsCache } from '../../shared/caches/recentobjects.cache';
import { Usr_Log } from 'src/app/shared/models/usr_log';
import { FldrObjectUtil } from 'src/app/shared/utils/fldrobject.util';
import { UserPrivilegeFactory } from 'src/app/shared/caches/user-privilege.factory';
import { ToastrMessage } from 'src/app/shared/services/toastr.message';
import { Param } from 'src/app/shared/models/domain/param';
import { RepFolderWrapper } from '../parameter/repfolder.wrapper';
import { RepFolderManager } from '../parameter/repfolder.manager';
import { StateUrlCache } from 'src/app/shared/caches/stateurl.cache';
import { RepFolder } from 'src/app/shared/models/objects/repfolder';
import { Usr_CfgFactory } from 'src/app/shared/caches/usrcfg.factory';
import { ThemeService } from 'src/app/theme/theme.factory';
import { RouterService } from 'src/app/shared/services/router.service';

/**
 * RepositoryManager is the root manager for entire studio module.
 */
@Injectable({
    providedIn: 'root',
})
export class RepositoryManager {
    util: Util;
    listFactory: ListFactory;
    sessionFactory: SessionFactory;
    userPrivilegeFactory: UserPrivilegeFactory;
    recentObjectsFactory: RecentObjectsCache;
    repository: Repository;
    usr_CfgFactory: Usr_CfgFactory

    usr_Logs: Array<Usr_Log>;

    openedUsr_Logs: Array<Usr_Log>;

    private _savedCount: number;
    stateUrlCache: StateUrlCache;
    recentlyOpenedGridObjects: any;
    constructor(private serviceManager: ServiceManager,
        private themeService: ThemeService,
        private routerService: RouterService,
        private toastrMessage: ToastrMessage) {
        this.sessionFactory = SessionFactory.getInstance();
        this.repository = Repository.getInstance();
        this.userPrivilegeFactory = UserPrivilegeFactory.getInstance();
        this.recentObjectsFactory = RecentObjectsCache.getInstance();
        this.stateUrlCache = StateUrlCache.getInstance();
        this.usr_CfgFactory = Usr_CfgFactory.getInstance();

        this.repository.fldrObjectWrappersMap = new Map<number, FldrObjectWrapper>();

        this.listFactory = ListFactory.getInstance();
        this.util = Util.getInstance();

        this.usr_Logs = new Array<Usr_Log>();
        this.openedUsr_Logs = new Array<Usr_Log>();

        this.repository.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this._savedCount = 0;
    }

    setDefault() {
        this.usr_Logs.splice(0, this.usr_Logs.length);
        this.openedUsr_Logs.splice(0, this.openedUsr_Logs.length);
        this.repository.fldrObjectWrappersMap.clear();
        this.repository.fldrObjectWrapper.clear();
    }

    verifySession(fromLoginPage: boolean = false, showBusyCursor: boolean = false): Observable<DIMsgObj> {
        return new Observable(observer => {
            this.serviceManager.session(fromLoginPage)
                .subscribe(diMsgObj => {
                    if (!fromLoginPage) {
                        let url = window.location.hash.slice(1, window.location.hash.length)
                        if (url != this.stateUrlCache.url)
                            this.stateUrlCache.setUrl(window.location.href);
                    }

                    if (diMsgObj.error_Cd != "0") {
                        if (!fromLoginPage) {
                            this.listFactory.showSessionExpiredPopup();
                        }
                        observer.next(diMsgObj);
                        return;
                    }
                    if (diMsgObj.persistVal.licenseErrorFlag == 'Y' && !fromLoginPage) {
                        this.toastrMessage.showWarningToastr(diMsgObj.persistVal.licenseErrorMsg);
                        let adminLicUrl: string = this.routerService.getSERVER_LICUrl();
                        let anchorElement = document.createElement('a');
                        anchorElement.setAttribute('href', adminLicUrl);
                        anchorElement.click();
                        return;
                    }

                    // An OIDC session is handled exactly like a password one from here on. An earlier
                    // branch returned before observer.next() whenever auth_method was 'oidc', which left
                    // the login page blank after every SSO sign-in (the token it stored was never read).
                    if (this.sessionFactory.buildVersion == '') {
                        this.serviceManager.getVersion()
                            .subscribe(diMsgObj => {
                                this.sessionFactory.buildVersion = diMsgObj.retMsgObject.slice(0, 10);
                            })
                    }
                    if (this.sessionFactory.usr.usr_Id != -1) {
                        this.sessionFactory.update(diMsgObj);
                        this.packUserPrivileges().subscribe(() => {
                            let fldr_Id = this.sessionFactory.fldr_Id;
                            if (this.stateUrlCache.url != '') {
                                let fldr_IdString = this.stateUrlCache.url.slice(5, this.stateUrlCache.url.length);
                                fldr_Id = parseInt(fldr_IdString.slice(0, fldr_IdString.indexOf('/')));
                            }

                            if (fldr_Id != this.sessionFactory.fldr_Id) {
                                this.serviceManager.getFldr(fldr_Id, showBusyCursor)
                                    .subscribe(diMsgObj => {
                                        if (diMsgObj.error_Cd != "0") {
                                            observer.next(diMsgObj);
                                            return;
                                        }
                                        diMsgObj.retMsgObject.imageUrl = 'assets/' + diMsgObj.retMsgObject.imageUrl.slice(4, diMsgObj.retMsgObject.imageUrl.length)
                                        this.sessionFactory.updateFldr(diMsgObj.retMsgObject);
                                        observer.next(diMsgObj);
                                        return;
                                    });
                            }
                            this.sessionFactory.updateFldr(this.sessionFactory.fldr);
                        })
                        observer.next(diMsgObj);
                        return;
                    }

                    this.sessionFactory.update(diMsgObj);
                    this.packUserPrivileges().subscribe(() => {
                        if (this.sessionFactory.licenseErrorFlag == 'Y') {
                            this.toastrMessage.showWarningToastr(diMsgObj.persistVal.licenseErrorMsg);
                            return;
                        }
                        if (this.sessionFactory.fldr.nm == '' &&
                            this.sessionFactory.fldr_Id != -1) {
                            let fldr_Id = this.sessionFactory.fldr_Id;
                            if (this.stateUrlCache.url != '') {
                                let fldr_IdString = this.stateUrlCache.url.slice(5, this.stateUrlCache.url.length);
                                fldr_Id = parseInt(fldr_IdString.slice(0, fldr_IdString.indexOf('/')));
                            }

                            this.serviceManager.getFldr(fldr_Id, showBusyCursor)
                                .subscribe(diMsgObj => {
                                    diMsgObj.retMsgObject.imageUrl = 'assets/' + diMsgObj.retMsgObject.imageUrl.slice(4, diMsgObj.retMsgObject.imageUrl.length)
                                    this.sessionFactory.updateFldr(diMsgObj.retMsgObject);
                                    observer.next(diMsgObj);
                                });

                            return;
                        }

                        observer.next(diMsgObj);
                    });
                })
        })
    }

    packUserPrivileges() {
        return new Observable(observer => {
            if (this.userPrivilegeFactory.privileges.length != 0 && this.sessionFactory.adminChangeFlg == 'N') {
                observer.next();
                return;
            }
            this.serviceManager.selectAdminObject(this.sessionFactory.usr.usr_Id, 'USER_PREFERENCES', 'N', -1, false)
                .subscribe(diMsgObj => {
                    this.usr_CfgFactory.packUsr_Cfgs(diMsgObj.retMsgObjects);
                    this.userPrivilegeFactory.packPrivileges(diMsgObj.retMsgObject);
                    for (let i: number = 0; i < this.usr_CfgFactory.usr_Cfgs.length; i++) {
                        let usr_Cfg = this.usr_CfgFactory.usr_Cfgs[i];
                        if (usr_Cfg.usr_Cfg_Cd != "THEME_COLOR") continue;
                        this.themeService.setTheme(usr_Cfg.usr_Cfg_Val);
                    }
                    observer.next();
                });
        });
    }

    createFldrObjectWrapper(fldr: Fldr): FldrObjectWrapper {
        this.repository.fldrObjectWrapper = this.repository.fldrObjectWrappersMap[fldr.fldr_Id];
        if (this.repository.fldrObjectWrapper) return this.repository.fldrObjectWrapper;

        let fldrObject: FldrObject = new FldrObject();
        fldrObject.fldr = fldr;

        this.repository.fldrObjectWrapper = new FldrObjectWrapper(fldrObject);
        this.repository.fldrObjectWrappersMap.set(this.repository.fldrObjectWrapper.fldr_Id, this.repository.fldrObjectWrapper);
    }

    getFldrObjectWrapper(fldr_Id: number): FldrObjectWrapper {
        return this.repository.fldrObjectWrappersMap.get(fldr_Id);
    }

    getObjectWrapper(obj_Id: number): ObjectWrapper {
        let objectWrapper: ObjectWrapper = this.repository.fldrObjectWrapper.objectWrappersMap.get(obj_Id);
        if (!objectWrapper) return null;

        return objectWrapper;
    }

    addFldrObjectWrapper(fldrObjectTmp: FldrObject): void {
        let fldrObjectWrapper: FldrObjectWrapper = this.repository.fldrObjectWrappersMap.get(fldrObjectTmp.fldr.fldr_Id);
        if (fldrObjectWrapper) return;

        fldrObjectWrapper = new FldrObjectWrapper(fldrObjectTmp);
        this.repository.fldrObjectWrapper = fldrObjectWrapper;
        this.repository.fldrObjectWrappersMap.set(fldrObjectWrapper.fldr_Id, fldrObjectWrapper);
    }

    setChange_Ind(): void {
        this.repository.setChange_Ind();
    }

    get change_Ind(): string {
        return this.repository.change_Ind;
    }

    get fldrObjectWrapper(): FldrObjectWrapper {
        return this.repository.fldrObjectWrapper;
    }

    /**
     * save() method used to save the object one by one synchrously.
     */
    save(): Observable<DIMsgObj> {
        return new Observable(observer => {
            // let unsavedObjects: Array<any> = this.repository.fldrObjectWrapper.fldrObject.getUnSavedObjects();
            let unsavedObjects: Array<any> = this.repository.fldrObjectWrapper.getUnsavedObjectsInOrder();

            if (unsavedObjects.length == 0) {
                let diMsgObj: DIMsgObj = new DIMsgObj();
                observer.next(diMsgObj);
                return;
            }

            this._savedCount = 0;
            this._saveObject(unsavedObjects)
                .subscribe(diMsgObj => {
                    if (diMsgObj.error_Cd != "0") {
                        observer.next(diMsgObj);
                        return;
                    }

                    observer.next(diMsgObj);
                })
        });
    }

    private _saveObject(unsavedObjects: Array<any>): Observable<DIMsgObj> {
        return new Observable(observer => {
            let unsavedObject: any = unsavedObjects[this._savedCount];


            if (unsavedObject.hasOwnProperty('fldr')) {
                let repFolder: RepFolder = unsavedObject as RepFolder;
                let unsavedProjectparams: Array<any> = this.repository.fldrObjectWrapper.getUnsavedProjectParams(repFolder.fldr.fldr_Id);
                let diMsgObject: any = new DIMsgObj();
                diMsgObject.retMsgObjects = unsavedProjectparams;

                this.serviceManager.saveProjectParam(diMsgObject, repFolder.fldr.fldr_Id, false)
                    .subscribe(diMsgObj => {
                        if(diMsgObj.error_Cd == 'ESM00679'){
                            this.toastrMessage.showErrorToastr(diMsgObj.error_Msg + "Please revert the changes.");
                            observer.next(diMsgObj);
                            return;
                        }else
                        if (diMsgObj.error_Cd != "0") {
                            observer.next(diMsgObj);
                            return;
                        }

                        let repFolderWrapper = this.repository.fldrObjectWrapper.objectWrappersMap.get(repFolder.fldr.fldr_Id) as RepFolderWrapper;
                        if (repFolderWrapper) {
                            for (let i: number = 0; i < repFolderWrapper.repFolder.params.length; i++) {
                                repFolderWrapper.repFolder.params[i].change_Ind = 'N';
                            }
                            repFolderWrapper.repFolder.change_Ind = 'N';
                        }

                        repFolderWrapper.objectCopy = RepFolder.parse(repFolderWrapper.repFolder);
                        // this.repository.fldrObjectWrapper.fldrObject.params = repFolderWrapper.repFolder.params;
                        // this.repository.fldrObjectWrapper.fldrObject.paramsCopy = repFolderWrapper.objectCopy.params;
                        this.repository.fldrObjectWrapper.fldrObject.deleteParams.splice(0, this.repository.fldrObjectWrapper.fldrObject.deleteParams.length);

                        if (unsavedObjects.length - 1 == this._savedCount) {
                            this._savedCount = 0;
                            this.repository.setChange_Ind();
                            observer.next(diMsgObj);
                        } else {
                            this._savedCount++;
                            this._saveObject(unsavedObjects)
                                .subscribe(diMsgObj => {
                                    if (diMsgObj.error_Cd != "0") {
                                        observer.next(diMsgObj);
                                        return;
                                    }
                                    observer.next(diMsgObj);
                                })
                        }
                    });
            } else if (unsavedObject.hasOwnProperty('fla_Fldrs')) {
                let diMsgObjTmp: DIMsgObj = new DIMsgObj();
                diMsgObjTmp.retMsgObject = unsavedObject;

                this.serviceManager.saveAdminObject(diMsgObjTmp, "FLDR", true)
                    .subscribe(diMsgObj => {
                        if (diMsgObj.error_Cd != "0") {
                            this._savedCount = 0;
                            return;
                        }

                        let object = this.repository.fldrObjectWrapper.fldrObject.getObjectById(unsavedObject.fldr.fldr_Id);
                        if (object) {
                            let repFolder: RepFolder = object as RepFolder;
                            repFolder.change_Ind = 'N';
                        }

                        if (unsavedObjects.length - 1 == this._savedCount) {
                            this._savedCount = 0;
                            this.repository.setChange_Ind();
                            observer.next(diMsgObj);
                        } else {
                            this._savedCount++;
                            this._saveObject(unsavedObjects)
                                .subscribe(diMsgObj => {
                                    if (diMsgObj.error_Cd != "0") {
                                        observer.next(diMsgObj);
                                        return;
                                    }
                                    observer.next(diMsgObj);
                                })
                        }
                    });
            } else if (unsavedObject.hasOwnProperty('dxMp') &&
                (unsavedObject as Design).dxMp.streamingFlg != CommonEnums.streamingFlg.DATACONNECT) {
                let design: Design = unsavedObject as Design;

                let diMsgObjTmp = new DIMsgObj();
                diMsgObjTmp.persistVal[design.dxMp.dxMp_Id] = design.change_Ind;
                this.serviceManager.saveInMemoryObject(diMsgObjTmp, true)
                    .subscribe(diMsgObj => {
                        if (diMsgObj.error_Cd != "0") {
                            observer.next(diMsgObj);
                            return;
                        }

                        let designWrapper: DesignWrapper = this.getObjectWrapper((diMsgObj.retMsgObjects[0] as Design).dxMp.dxMp_Id) as DesignWrapper;
                        if (designWrapper) {
                            if (designWrapper.change_Ind == CommonEnums.change_Ind.DELETED) {
                                this.repository.fldrObjectWrapper.objectWrappersMap.delete(designWrapper.obj_Id);
                                this.fldrObjectWrapper.spliceDeletedObjectWrapper(designWrapper.obj_Id);
                                this.repository.fldrObjectWrapper.fldrObject.splice(designWrapper.object, designWrapper.obj_Id, designWrapper.obj_Cd);
                                this.fldrObjectWrapper.spliceGridObject(designWrapper.obj_Id, designWrapper.obj_Cd, designWrapper.reusableFlag, designWrapper.streamingFlg);
                                this.spliceOpenedUsr_Log(designWrapper.obj_Id);
                            } else {
                                designWrapper.updateObject(diMsgObj.retMsgObjects[0]);
                            }
                        }

                        if (unsavedObjects.length - 1 == this._savedCount) {
                            this._savedCount = 0;
                            this.repository.setChange_Ind();
                            observer.next(diMsgObj);
                        } else {
                            this._savedCount++;
                            this._saveObject(unsavedObjects)
                                .subscribe(diMsgObj => {
                                    if (diMsgObj.error_Cd != "0") {
                                        observer.next(diMsgObj);
                                        return;
                                    }

                                    observer.next(diMsgObj);
                                })
                        }
                    });
            } else {
                let diMsgObjTmp: DIMsgObj = new DIMsgObj();
                diMsgObjTmp.retMsgObject = unsavedObject;

                this.serviceManager.saveObject(diMsgObjTmp)
                    .subscribe(diMsgObj => {
                        if (diMsgObj.error_Cd != "0") {
                            observer.next(diMsgObj);
                            return;
                        }

                        let obj_Id: number = FldrObjectUtil.getInstance().getObj_Id(diMsgObj.retMsgObject);
                        let objectWrapper: ObjectWrapper = this.getObjectWrapper(obj_Id);
                        if (objectWrapper) {
                            if (diMsgObj.retMsgObject.change_Ind == CommonEnums.change_Ind.DELETED) {
                                this.fldrObjectWrapper.objectWrappersMap.delete(obj_Id);
                                this.fldrObjectWrapper.spliceDeletedObjectWrapper(obj_Id);
                                this.fldrObjectWrapper.fldrObject.splice(diMsgObj.retMsgObject);
                                this.fldrObjectWrapper.spliceGridObject(obj_Id, objectWrapper.obj_Cd, objectWrapper.reusableFlag, objectWrapper.streamingFlg);
                                this.spliceOpenedUsr_Log(obj_Id);
                            } else {
                                objectWrapper.updateObject(diMsgObj.retMsgObject);
                            }
                        }

                        if (unsavedObjects.length - 1 == this._savedCount) {
                            this._savedCount = 0;
                            this.repository.setChange_Ind();
                            observer.next(diMsgObj);
                        } else {
                            this._savedCount++;
                            this._saveObject(unsavedObjects)
                                .subscribe(diMsgObj => {
                                    if (diMsgObj.error_Cd != "0") {
                                        observer.next(diMsgObj);
                                        return;
                                    }

                                    observer.next(diMsgObj);
                                })
                        }
                    });
            }
        });
    }

    private revertPerformance(unsavedDxMp_Ids: Array<number>): Observable<any> {
        return new Observable(observer => {
            if (unsavedDxMp_Ids.length == 0) {
                let diMsgObj: DIMsgObj = new DIMsgObj();
                observer.next(diMsgObj);
                return;
            }

            this.serviceManager.revertPerformace(this.repository.fldrObjectWrapper.fldr_Id, unsavedDxMp_Ids, true)
                .subscribe(diMsgObj => {
                    for (let i: number = 0; i < unsavedDxMp_Ids.length; i++) {
                        let objectWrapper: ObjectWrapper = this.repository.fldrObjectWrapper.objectWrappersMap.get(unsavedDxMp_Ids[i]);
                        if (objectWrapper) {
                            if (objectWrapper.change_Ind == CommonEnums.change_Ind.CREATED) {
                                this.repository.fldrObjectWrapper.objectWrappersMap.delete(objectWrapper.obj_Id);
                                this.repository.fldrObjectWrapper.fldrObject.splice(objectWrapper.object, objectWrapper.obj_Id, objectWrapper.obj_Cd);
                                this.fldrObjectWrapper.spliceGridObject(objectWrapper.obj_Id, objectWrapper.obj_Cd,
                                    objectWrapper.reusableFlag, objectWrapper.streamingFlg);
                                this.spliceOpenedUsr_Log(objectWrapper.obj_Id);
                            } else {
                                // objectWrapper.updateObject(objectWrapper.objectCopy);
                                for (let j = 0; j < diMsgObj.retMsgObjects.length; j++) {
                                    if (diMsgObj.retMsgObjects[j].dxMp.dxMp_Id == objectWrapper.obj_Id)
                                        objectWrapper.updateObject(diMsgObj.retMsgObjects[j]);
                                }

                            }
                        }
                    }

                    this.repository.setChange_Ind();
                    observer.next(diMsgObj);
                });
        });
    }

    revert(): Observable<DIMsgObj> {
        return new Observable(observer => {
            let unsavedDxMp_Ids: Array<number> = this.repository.fldrObjectWrapper.fldrObject.getUnsavedDxMp_Ids();
            let unsavedObj_Ids: Array<number> = this.repository.fldrObjectWrapper.fldrObject.getUnsavedObj_Ids();
            let unsavedProjectparams = this.repository.fldrObjectWrapper.fldrObject.getUnsavedProjectParams();

            if (this.listFactory.streamingFlg == CommonEnums.streamingFlg.DATACONNECT) {
                for (let i: number = 0; i < unsavedDxMp_Ids.length; i++) {
                    unsavedObj_Ids.push(unsavedDxMp_Ids[i]);
                }
                unsavedDxMp_Ids.splice(0, unsavedDxMp_Ids.length);
            }

            if (unsavedObj_Ids.length > 0) {
                this.serviceManager.deletenmlock(this.repository.fldrObjectWrapper.fldr_Id, unsavedObj_Ids, true)
                    .subscribe(diMsgObj => {
                        if (diMsgObj.error_Cd != "0") {
                            observer.next(diMsgObj);
                            return;
                        }

                        for (let i: number = 0; i < unsavedObj_Ids.length; i++) {
                            let objectWrapper: ObjectWrapper = this.repository.fldrObjectWrapper.objectWrappersMap.get(unsavedObj_Ids[i]);
                            if (objectWrapper) {
                                if (objectWrapper.change_Ind == CommonEnums.change_Ind.CREATED) {
                                    this.fldrObjectWrapper.objectWrappersMap.delete(objectWrapper.obj_Id);
                                    this.fldrObjectWrapper.fldrObject.splice(objectWrapper.object, objectWrapper.obj_Id, objectWrapper.obj_Cd);
                                    this.fldrObjectWrapper.spliceGridObject(objectWrapper.obj_Id, objectWrapper.obj_Cd,
                                        objectWrapper.reusableFlag, objectWrapper.streamingFlg);
                                    this.spliceOpenedUsr_Log(objectWrapper.obj_Id);
                                } else {
                                    objectWrapper.updateObject(objectWrapper.objectCopy);
                                }
                            }
                        }
                        this.repository.setChange_Ind();

                        if (unsavedProjectparams.length > 0) {
                            this.revertUnsavedProjectParameters()
                                .subscribe(() => {
                                    // observer.next(diMsgObj);
                                });
                        }

                        if (unsavedDxMp_Ids.length > 0 &&
                            this.listFactory.streamingFlg != CommonEnums.streamingFlg.DATACONNECT) {
                            this.revertPerformance(unsavedDxMp_Ids)
                                .subscribe(() => {
                                    observer.next(diMsgObj);
                                });
                        } else {
                            observer.next(diMsgObj);
                        }
                    });
            }

            if (unsavedDxMp_Ids.length > 0 &&
                this.listFactory.streamingFlg != CommonEnums.streamingFlg.DATACONNECT) {
                this.revertPerformance(unsavedDxMp_Ids)
                    .subscribe(diMsgObj => {
                        this.repository.setChange_Ind();
                        observer.next(diMsgObj);
                    });
            }

            if (unsavedProjectparams.length > 0 && (unsavedDxMp_Ids.length == 0 && unsavedObj_Ids.length == 0)) {
                this.revertUnsavedProjectParameters()
                    .subscribe(() => {
                        this.repository.setChange_Ind();
                        observer.next();
                    });
            }
        });
    }

    revertUnsavedProjectParameters(): Observable<any> {
        return new Observable(observer => {
            // let repFolderWrapper: RepFolderWrapper = this.repFolderManager.get(this.sessionFactory.fldr.fldr_Id.toString());
            let repFolderWrapper = this.repository.fldrObjectWrapper.objectWrappersMap.get(this.sessionFactory.fldr.fldr_Id) as RepFolderWrapper;
            repFolderWrapper.updateObject(repFolderWrapper.objectCopy);
            this.repository.fldrObjectWrapper.fldrObject.deleteParams.splice(0, this.repository.fldrObjectWrapper.fldrObject.deleteParams.length);
            this.repository.setChange_Ind();
            observer.next();
        });
    }

    /** BugId#9647
     * @param {number} obj_Id default value is -1
     * 1) pack the opened object_Ids
     * 2) if obj_Id arg is not equal to -1 then skip that in obj_Ids;
     * 3) call deletenmlock api with folder_Id and openedobject_Ids to unlock names
     * 4) after get response then check is there any dataflow ids present in opened objects
     *  i) if yes then pack dataflow ids and loop them and call dropTformsDataFlow() method to debug off
     * 5) clear openedUsr_logs list
     * 6) call unlock api to unlock all opened objects
    */
    closeAll(obj_Id: number = -1): Observable<DIMsgObj> {
        return new Observable(observer => {
            let openedObj_Ids: Array<number> = new Array<number>();
            for (let i: number = 0; i < this.openedUsr_Logs.length; i++) {
                if (this.openedUsr_Logs[i].obj_Id == obj_Id) continue;
                openedObj_Ids.push(this.openedUsr_Logs[i].obj_Id);
            }

            this.serviceManager.deletenmlock(this.repository.fldrObjectWrapper.fldr_Id, openedObj_Ids, true)
                .subscribe(diMsgObj => {
                    if (diMsgObj.error_Cd != "0") {
                        observer.next(diMsgObj);
                        return;
                    }

                    let dataflowIds: Array<number> = new Array<number>();
                    let deletedObj_Ids: Array<number> = new Array<number>();
                    let obj_IdsHMap: any = {};

                    for (let i: number = 0; i < this.openedUsr_Logs.length; i++) {
                        if (this.openedUsr_Logs[i].obj_Id == obj_Id) continue;
                        obj_IdsHMap[this.openedUsr_Logs[i].obj_Id] = this.openedUsr_Logs[i].obj_Cd;
                        deletedObj_Ids.push(this.openedUsr_Logs[i].obj_Id);

                        if (this.openedUsr_Logs[i].obj_Cd == CommonEnums.codes.DESIGN) {
                            dataflowIds.push(this.openedUsr_Logs[i].obj_Id);
                        }

                        this.openedUsr_Logs.splice(i, 1);
                        i--;
                    }

                    for (let i: number = 0; i < dataflowIds.length; i++) { //Interactive Debugger
                        this.dropTformsDataFlow(dataflowIds[i]);
                    }

                    let diMsgObjectEmpty = new DIMsgObj();
                    diMsgObjectEmpty.persistVal = obj_IdsHMap;

                    this.serviceManager.unlock(this.sessionFactory.fldr.fldr_Id, diMsgObjectEmpty)
                        .subscribe(() => {
                            this.fldrObjectWrapper.spliceObjectWrappers(deletedObj_Ids);
                            observer.next(diMsgObj);
                        });
                });
        })
    }

    // Opened Usr_Log
    unshiftOpenedUsr_Logs(usr_Log: Usr_Log): void {
        this.openedUsr_Logs.unshift(usr_Log);
    }

    getOpenedUsr_Log(obj_Id: number): Usr_Log {
        for (let i: number = 0; i < this.openedUsr_Logs.length; i++) {
            if (this.openedUsr_Logs[i].obj_Id == obj_Id) {
                return this.openedUsr_Logs[i];
            }
        }

        return null;
    }

    spliceOpenedUsr_Log(obj_Id: number): Array<Usr_Log> {
        for (let i: number = 0; i < this.openedUsr_Logs.length; i++) {
            if (this.openedUsr_Logs[i].obj_Id == obj_Id) {
                return this.openedUsr_Logs.splice(i, 1);
            }
        }

        return null;
    }

    // closeAllOpenedObjects(objIds: Array<number>): any {

    //     let openedObjectsIds:any = {};
    //     let designIds = [];
    //     let dataflowIds = [];

    //     if( objIds.length > 0) {
    //         for( let i: number = 0; i < objIds.length; i++) {
    //             let objectWrapper =  this.fldrObjectWrapper.objectWrappersMap.get(objIds[i]);
    //             if( !objectWrapper) return;

    //             this.repository.fldrObjectWrapper.objectWrappersMap.delete(objectWrapper.obj_Id);
    //             openedObjectsIds[objectWrapper.obj_Id] = objectWrapper.obj_Cd);

    //             if( objectWrapper.obj_Cd == 'DXMP'){
    //                 dataflowIds.push( objectWrapper.obj_Id );
    //               }
    //         }

    //         for( let k: number = 0; k < dataflowIds.length; k++ ){ //Interactive Debugger
    //             this.dropTformsDataFlow( dataflowIds[k] );
    //           }

    //     }

    //       return openedObjectsIds;

    //   }

    dropTformsDataFlow(obj_Id: number): void {
        setTimeout(() => {
            this.serviceManager.debugoff(obj_Id, true)
                .subscribe(diMsgObj => {
                });
        });
    }
}